/**
 * TK-10684 Alpha — when true, hide Alpha-gated UI until Beta. Beta: set to false.
 *
 * Three surfaces read it today:
 * - custom handwriting font tile (TK-10650) — `FontSelectorField.vue`
 * - review credits summary (TK-10679) — `HandwrittenNotePersonalize/index.vue`
 * - profile/account CTA in popovers (TK-10681) — `CustomerMenu.vue`
 *
 * **No longer the Contacts bottom nav (TK-10680).** That moved to
 * `useFeatureFlag('contacts-page')` in TK-12919/TK-13117 and `BottomNavbar.vue` does not import
 * this constant at all — the tab is flag-only, not ANDed with this.
 *
 * A stand-in that outlived its excuse: the real flag registry now exists
 * (`constants/featureFlag.ts`), and bundling unrelated toggles behind one boolean means none of
 * them can be released independently. Migrating them is tracked in
 * `doc/spec/SPEC_feature_flags_coverage.md`.
 */
export const HIDE_FOR_ALPHA = true
